// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs-module-b0b55bf86e9fc824bb57","wrapper":"Tabs-module-cd2a3ccb7e7a7728d7d3","leftArrow":"Tabs-module-e225620c1fd336d90e15","rightArrow":"Tabs-module-f38fab1109d3f75bd6e0"};